// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"ef3ef483","453":"8bd7e56d"}[chunkId] + ".chunk.js";
};